// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Portal routes: Our Memories ink / stone — light/dark via html.dark */

/* ── Studio Dashboard (legacy premium-dashboard) ── */
.premium-dashboard {
  --sd-page-bg: #ffffff;
  --sd-text: #0f172a;
  --sd-text-muted: #94a3b8;
  --sd-text-secondary: #64748b;
  --sd-card: #ffffff;
  --sd-card-border: rgba(15, 23, 42, 0.1);
  --sd-hero: linear-gradient(135deg, #ffffff 0%, #ffffff 35%, #eff6ff 100%);
  --sd-hero-border: rgba(15, 23, 42, 0.1);
  --sd-chip-bg: rgba(255, 252, 248, 0.85);
  --sd-accent-soft: #f1f5f9;
  --sd-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);
}

html.dark .premium-dashboard {
  --sd-page-bg: #151412;
  --sd-text: #ffffff;
  --sd-text-muted: #a8a399;
  --sd-text-secondary: #e2e8f0;
  --sd-card: #1c1a18;
  --sd-card-border: rgba(255, 255, 255, 0.1);
  --sd-hero: linear-gradient(135deg, #1c1a18 0%, #151412 35%, #0f0e0c 100%);
  --sd-hero-border: rgba(255, 255, 255, 0.1);
  --sd-chip-bg: rgba(28, 26, 24, 0.9);
  --sd-accent-soft: #1d4ed8;
  --sd-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);
}

.premium-dashboard {
  background: var(--sd-page-bg) !important;
  color: var(--sd-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.premium-dashboard .bg-white {
  background-color: var(--sd-card) !important;
  border-color: var(--sd-card-border);
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.premium-dashboard .sd-hero-panel {
  background: var(--sd-hero) !important;
  border-color: var(--sd-hero-border) !important;
  box-shadow: var(--sd-shadow) !important;
}

.premium-dashboard .sd-chip {
  border-color: var(--sd-card-border) !important;
  background: var(--sd-chip-bg) !important;
  color: var(--sd-text) !important;
}

.premium-dashboard .sd-icon-well {
  background: var(--sd-accent-soft) !important;
  border-color: var(--sd-card-border) !important;
}

/* ── Upload Family Images ── */
.upload-family-page {
  --uf-bg: #ffffff;
  --uf-text: #0f172a;
  --uf-muted: #64748b;
  --uf-border: rgba(15, 23, 42, 0.14);
  --uf-surface: #ffffff;
  --uf-surface-soft: #f1f5f9;
  --uf-accent: #2563eb;
  --uf-accent-soft: #f1f5f9;
  --uf-tab-track: #f1f5f9;
}

html.dark .upload-family-page {
  --uf-bg: #151412;
  --uf-text: #ffffff;
  --uf-muted: #a8a399;
  --uf-border: rgba(255, 255, 255, 0.12);
  --uf-surface: #1c1a18;
  --uf-surface-soft: #1d4ed8;
  --uf-accent: #e2e8f0;
  --uf-accent-soft: #1d4ed8;
  --uf-tab-track: #1c1a18;
}

.upload-family-page {
  background-color: var(--uf-bg) !important;
  color: var(--uf-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.upload-family-page .uf-card {
  border-color: color-mix(in srgb, var(--uf-border) 80%, transparent);
  background: color-mix(in srgb, var(--uf-surface) 70%, transparent);
}

.upload-family-page .uf-surface {
  background-color: var(--uf-surface) !important;
  border-color: var(--uf-border) !important;
  color: var(--uf-text);
}

.upload-family-page .uf-tab-track {
  background-color: var(--uf-tab-track) !important;
}

.upload-family-page .uf-tab-active {
  background-color: var(--uf-surface) !important;
  color: var(--uf-accent) !important;
}

.upload-family-page .uf-footer-bar {
  background: color-mix(in srgb, var(--uf-surface) 90%, transparent) !important;
  border-color: var(--uf-border) !important;
}

/* ── Photo Themes hub ── */
.photo-themes-hub {
  --pt-text: #0f172a;
  --pt-muted: #64748b;
  --pt-card: rgba(255, 255, 255, 0.95);
  --pt-card-border: rgba(15, 23, 42, 0.1);
}

html.dark .photo-themes-hub {
  --pt-text: #ffffff;
  --pt-muted: #a8a399;
  --pt-card: rgba(28, 26, 24, 0.92);
  --pt-card-border: rgba(255, 255, 255, 0.1);
}

.photo-themes-hub {
  color: var(--pt-text);
}

.photo-themes-hub .pt-stat-card {
  background: var(--pt-card);
  border-color: var(--pt-card-border);
}

.photo-themes-glass-card {
  border-radius: 1.5rem;
  border: 1px solid color-mix(in srgb, var(--pt-card-border) 80%, transparent);
  background: var(--pt-card);
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  backdrop-filter: blur(12px);
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.photo-themes-hub h2,
.photo-themes-hub .pt-section-title {
  color: var(--pt-text);
}

.photo-themes-hub .pt-muted {
  color: var(--pt-muted);
}

/* ── Portal layout shell (all nav routes) ── */
.portal-page-surface {
  --pp-bg: #ffffff;
  --pp-surface: #ffffff;
  --pp-surface-muted: #f1f5f9;
  --pp-text: #0f172a;
  --pp-text-muted: #64748b;
  --pp-text-faint: #94a3b8;
  --pp-border: rgba(15, 23, 42, 0.1);
  --pp-accent: #2563eb;
  --pp-ink: #0f172a;
  color: var(--pp-text);
  font-family: "Outfit", "Segoe UI", sans-serif;
  transition: color 0.2s ease, background-color 0.2s ease;
}

html.dark .portal-page-surface {
  --pp-bg: #151412;
  --pp-surface: #1c1a18;
  --pp-surface-muted: #1d4ed8;
  --pp-text: #ffffff;
  --pp-text-muted: #a8a399;
  --pp-text-faint: #78746c;
  --pp-border: rgba(255, 255, 255, 0.1);
  --pp-accent: #e2e8f0;
  --pp-ink: #ffffff;
  color-scheme: dark;
}

.portal-page-surface .portal-card {
  border-radius: 1rem;
  border: 1px solid var(--pp-border);
  background-color: var(--pp-surface);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.portal-page-surface .portal-header-bar {
  background-color: var(--pp-bg);
  border-bottom: 1px solid var(--pp-border);
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

/* Catch pages/components still using light-only Tailwind grays */
.portal-page-surface .bg-white {
  background-color: var(--pp-surface) !important;
}

.portal-page-surface .bg-gray-50,
.portal-page-surface .bg-slate-50 {
  background-color: var(--pp-surface-muted) !important;
}

.portal-page-surface .bg-gray-100,
.portal-page-surface .bg-slate-100 {
  background-color: var(--pp-surface-muted) !important;
}

.portal-page-surface .border-gray-100,
.portal-page-surface .border-gray-200,
.portal-page-surface .border-slate-200 {
  border-color: var(--pp-border) !important;
}

.portal-page-surface .text-gray-900,
.portal-page-surface .text-slate-900 {
  color: var(--pp-text) !important;
}

.portal-page-surface .text-gray-800,
.portal-page-surface .text-gray-700,
.portal-page-surface .text-gray-600,
.portal-page-surface .text-slate-800,
.portal-page-surface .text-slate-700,
.portal-page-surface .text-slate-600 {
  color: var(--pp-text-muted) !important;
}

.portal-page-surface .text-gray-500,
.portal-page-surface .text-gray-400,
.portal-page-surface .text-gray-300,
.portal-page-surface .text-slate-500,
.portal-page-surface .text-slate-400 {
  color: var(--pp-text-faint) !important;
}

/* Remap SaaS blues / violets / purples / indigos → ink / stone
   (skip .sd-dash which has its own premium tokens) */
.portal-page-surface:not(:has(.sd-dash)) .bg-blue-50,
.portal-page-surface:not(:has(.sd-dash)) .bg-violet-50,
.portal-page-surface:not(:has(.sd-dash)) .bg-purple-50,
.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-50,
.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-50,
.portal-page-surface:not(:has(.sd-dash)) .bg-sky-50 {
  background-color: var(--pp-surface-muted) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .bg-blue-100,
.portal-page-surface:not(:has(.sd-dash)) .bg-violet-100,
.portal-page-surface:not(:has(.sd-dash)) .bg-purple-100,
.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-100 {
  background-color: #f1f5f9 !important;
}

.portal-page-surface:not(:has(.sd-dash)) .bg-blue-500,
.portal-page-surface:not(:has(.sd-dash)) .bg-blue-600,
.portal-page-surface:not(:has(.sd-dash)) .bg-violet-500,
.portal-page-surface:not(:has(.sd-dash)) .bg-violet-600,
.portal-page-surface:not(:has(.sd-dash)) .bg-purple-500,
.portal-page-surface:not(:has(.sd-dash)) .bg-purple-600,
.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-500,
.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-600,
.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-500,
.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-600 {
  background-color: var(--pp-accent) !important;
  color: #ffffff !important;
}

.portal-page-surface:not(:has(.sd-dash)) .text-blue-500,
.portal-page-surface:not(:has(.sd-dash)) .text-blue-600,
.portal-page-surface:not(:has(.sd-dash)) .text-blue-700,
.portal-page-surface:not(:has(.sd-dash)) .text-violet-500,
.portal-page-surface:not(:has(.sd-dash)) .text-violet-600,
.portal-page-surface:not(:has(.sd-dash)) .text-violet-700,
.portal-page-surface:not(:has(.sd-dash)) .text-purple-500,
.portal-page-surface:not(:has(.sd-dash)) .text-purple-600,
.portal-page-surface:not(:has(.sd-dash)) .text-purple-700,
.portal-page-surface:not(:has(.sd-dash)) .text-indigo-500,
.portal-page-surface:not(:has(.sd-dash)) .text-indigo-600,
.portal-page-surface:not(:has(.sd-dash)) .text-indigo-700,
.portal-page-surface:not(:has(.sd-dash)) .text-fuchsia-500,
.portal-page-surface:not(:has(.sd-dash)) .text-fuchsia-600 {
  color: var(--pp-accent) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .border-blue-100,
.portal-page-surface:not(:has(.sd-dash)) .border-blue-200,
.portal-page-surface:not(:has(.sd-dash)) .border-violet-100,
.portal-page-surface:not(:has(.sd-dash)) .border-violet-200,
.portal-page-surface:not(:has(.sd-dash)) .border-purple-100,
.portal-page-surface:not(:has(.sd-dash)) .border-purple-200,
.portal-page-surface:not(:has(.sd-dash)) .border-indigo-100,
.portal-page-surface:not(:has(.sd-dash)) .border-indigo-200 {
  border-color: var(--pp-border) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .border-blue-500,
.portal-page-surface:not(:has(.sd-dash)) .border-violet-500,
.portal-page-surface:not(:has(.sd-dash)) .border-purple-500,
.portal-page-surface:not(:has(.sd-dash)) .border-indigo-500 {
  border-color: var(--pp-accent) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .ring-blue-500,
.portal-page-surface:not(:has(.sd-dash)) .ring-violet-500,
.portal-page-surface:not(:has(.sd-dash)) .ring-purple-500,
.portal-page-surface:not(:has(.sd-dash)) .ring-indigo-400,
.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-blue-500:focus,
.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-violet-500:focus,
.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-purple-500:focus,
.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-indigo-500:focus {
  --tw-ring-color: rgba(37, 99, 235, 0.35) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-blue-50:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-violet-50:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-purple-50:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-indigo-50:hover {
  background-color: var(--pp-surface-muted) !important;
}

.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-blue-600:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-violet-600:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-purple-600:hover,
.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-indigo-600:hover {
  color: var(--pp-accent) !important;
}

html.dark .portal-page-surface .hover\\:bg-gray-50:hover,
html.dark .portal-page-surface .hover\\:bg-blue-50:hover,
html.dark .portal-page-surface .hover\\:bg-slate-50:hover,
html.dark .portal-page-surface .hover\\:bg-slate-100:hover {
  background-color: var(--pp-surface-muted) !important;
}

html.dark .portal-page-surface .hover\\:text-gray-700:hover,
html.dark .portal-page-surface .hover\\:text-gray-600:hover {
  color: var(--pp-text) !important;
}

.portal-page-surface input,
.portal-page-surface select,
.portal-page-surface textarea {
  background-color: var(--pp-surface);
  border-color: var(--pp-border);
  color: var(--pp-text);
}

.portal-page-surface input::placeholder,
.portal-page-surface textarea::placeholder {
  color: var(--pp-text-faint);
}

html.dark .portal-page-surface select option {
  background-color: var(--pp-surface);
  color: var(--pp-text);
}

/* ── Upload Family — hardcoded hex in JSX ── */
.upload-family-page .text-\\[\\#004ac6\\] {
  color: var(--uf-accent) !important;
}

.upload-family-page .text-\\[\\#505f76\\],
.upload-family-page .text-\\[\\#5f6c84\\] {
  color: var(--uf-muted) !important;
}

.upload-family-page .text-\\[\\#191b23\\],
.upload-family-page .text-\\[\\#1a1c24\\] {
  color: var(--uf-text) !important;
}

.upload-family-page .border-\\[\\#c3c6d7\\],
.upload-family-page .border-\\[\\#d5d8e4\\] {
  border-color: var(--uf-border) !important;
}

.upload-family-page .bg-\\[\\#f3f3fe\\],
.upload-family-page .bg-\\[\\#f5f6ff\\],
.upload-family-page .bg-\\[\\#eef4ff\\] {
  background-color: var(--uf-surface-soft) !important;
}

.upload-family-page .bg-white {
  background-color: var(--uf-surface) !important;
}

.upload-family-page .bg-\\[\\#004ac6\\] {
  background-color: var(--uf-accent) !important;
}

.upload-family-page .border-\\[\\#004ac6\\] {
  border-color: var(--uf-accent) !important;
}

/* ── Family tree floating panel ── */
.family-tree-scope .family-tree-panel {
  background: var(--pp-surface);
  border-color: var(--pp-border);
  color: var(--pp-text);
}

html.dark .family-tree-scope .family-tree-panel {
  background: var(--pp-surface);
  border-color: var(--pp-border);
}

.family-tree-scope .family-tree-panel .text-gray-800,
.family-tree-scope .family-tree-panel .text-gray-700 {
  color: var(--pp-text) !important;
}

.family-tree-scope .family-tree-panel .text-gray-500,
.family-tree-scope .family-tree-panel .text-gray-400 {
  color: var(--pp-text-faint) !important;
}

.family-tree-scope .family-tree-action {
  border-color: var(--pp-border);
  color: var(--pp-text-muted);
}

html.dark .family-tree-scope .family-tree-action:hover {
  background-color: rgba(31, 58, 52, 0.2) !important;
  border-color: #e2e8f0 !important;
}

/* ── Photo themes category (builder pages) ── */
.photo-themes-hub,
.photo-themes-category {
  color: var(--pt-text);
}

html.dark .photo-themes-category .text-\\[\\#0b1c30\\],
html.dark .photo-themes-category .text-\\[\\#464554\\] {
  color: var(--pt-text) !important;
}

html.dark .category-quantum-studio {
  background: #151412;
  color: #ffffff;
}

html.dark .category-quantum-studio .bg-white,
html.dark .category-quantum-studio .bg-white\\/90,
html.dark .category-quantum-studio .category-editor-panel,
html.dark .category-quantum-studio footer {
  background-color: #1c1a18 !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

html.dark .category-quantum-studio .bg-slate-50,
html.dark .category-quantum-studio .bg-slate-50\\/80 {
  background-color: #1d4ed8 !important;
}

html.dark .category-quantum-studio .text-\\[\\#0b1c30\\],
html.dark .category-quantum-studio .text-slate-900,
html.dark .category-quantum-studio h1,
html.dark .category-quantum-studio h2,
html.dark .category-quantum-studio h3 {
  color: #ffffff !important;
}

html.dark .category-quantum-studio .text-\\[\\#464554\\],
html.dark .category-quantum-studio .text-slate-600,
html.dark .category-quantum-studio .text-slate-500 {
  color: #a8a399 !important;
}

html.dark .category-quantum-studio .border-slate-100,
html.dark .category-quantum-studio .border-slate-200,
html.dark .category-quantum-studio .border-slate-200\\/60 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* ── Studio Albums + Client Images (scoped in page CSS) ── */
html.dark .studio-albums-scope,
html.dark .images-library-scope,
html.dark .admin-scope,
html.dark .premium-dashboard {
  color-scheme: dark;
}
`, "",{"version":3,"sources":["webpack://./src/styles/app-portal-pages.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,sDAAsD;AACtD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,uCAAuC;EACvC,yEAAyE;EACzE,uCAAuC;EACvC,uCAAuC;EACvC,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,0CAA0C;EAC1C,yEAAyE;EACzE,0CAA0C;EAC1C,mCAAmC;EACnC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,8DAA8D;AAChE;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,mEAAmE;EACnE,kEAAkE;AACpE;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,6EAA6E;EAC7E,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,4EAA4E;EAC5E,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;EAC3B,+EAA+E;AACjF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,mCAAmC;EACnC,6CAA6C;EAC7C,+EAA+E;AACjF;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,+EAA+E;AACjF;;AAEA,iEAAiE;AACjE;EACE,8CAA8C;AAChD;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;;;EAME,sCAAsC;AACxC;;AAEA;;;;;EAKE,sCAAsC;AACxC;;AAEA;qDACqD;AACrD;;;;;;EAME,oDAAoD;AACtD;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;;;;;;;;;EAUE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;EAcE,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,yCAAyC;AAC3C;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;;;;;;;;EAQE,mDAAmD;AACrD;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAGE,mCAAmC;EACnC,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;;EAGE,mDAAmD;AACrD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA,6DAA6D;AAC7D;;;;EAIE,kBAAkB;AACpB","sourcesContent":["/* Portal routes: Our Memories ink / stone — light/dark via html.dark */\n\n/* ── Studio Dashboard (legacy premium-dashboard) ── */\n.premium-dashboard {\n  --sd-page-bg: #ffffff;\n  --sd-text: #0f172a;\n  --sd-text-muted: #94a3b8;\n  --sd-text-secondary: #64748b;\n  --sd-card: #ffffff;\n  --sd-card-border: rgba(15, 23, 42, 0.1);\n  --sd-hero: linear-gradient(135deg, #ffffff 0%, #ffffff 35%, #eff6ff 100%);\n  --sd-hero-border: rgba(15, 23, 42, 0.1);\n  --sd-chip-bg: rgba(255, 252, 248, 0.85);\n  --sd-accent-soft: #f1f5f9;\n  --sd-shadow: 0 10px 40px rgba(15, 23, 42, 0.06);\n}\n\nhtml.dark .premium-dashboard {\n  --sd-page-bg: #151412;\n  --sd-text: #ffffff;\n  --sd-text-muted: #a8a399;\n  --sd-text-secondary: #e2e8f0;\n  --sd-card: #1c1a18;\n  --sd-card-border: rgba(255, 255, 255, 0.1);\n  --sd-hero: linear-gradient(135deg, #1c1a18 0%, #151412 35%, #0f0e0c 100%);\n  --sd-hero-border: rgba(255, 255, 255, 0.1);\n  --sd-chip-bg: rgba(28, 26, 24, 0.9);\n  --sd-accent-soft: #1d4ed8;\n  --sd-shadow: 0 10px 40px rgba(0, 0, 0, 0.35);\n}\n\n.premium-dashboard {\n  background: var(--sd-page-bg) !important;\n  color: var(--sd-text);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.premium-dashboard .bg-white {\n  background-color: var(--sd-card) !important;\n  border-color: var(--sd-card-border);\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.premium-dashboard .sd-hero-panel {\n  background: var(--sd-hero) !important;\n  border-color: var(--sd-hero-border) !important;\n  box-shadow: var(--sd-shadow) !important;\n}\n\n.premium-dashboard .sd-chip {\n  border-color: var(--sd-card-border) !important;\n  background: var(--sd-chip-bg) !important;\n  color: var(--sd-text) !important;\n}\n\n.premium-dashboard .sd-icon-well {\n  background: var(--sd-accent-soft) !important;\n  border-color: var(--sd-card-border) !important;\n}\n\n/* ── Upload Family Images ── */\n.upload-family-page {\n  --uf-bg: #ffffff;\n  --uf-text: #0f172a;\n  --uf-muted: #64748b;\n  --uf-border: rgba(15, 23, 42, 0.14);\n  --uf-surface: #ffffff;\n  --uf-surface-soft: #f1f5f9;\n  --uf-accent: #2563eb;\n  --uf-accent-soft: #f1f5f9;\n  --uf-tab-track: #f1f5f9;\n}\n\nhtml.dark .upload-family-page {\n  --uf-bg: #151412;\n  --uf-text: #ffffff;\n  --uf-muted: #a8a399;\n  --uf-border: rgba(255, 255, 255, 0.12);\n  --uf-surface: #1c1a18;\n  --uf-surface-soft: #1d4ed8;\n  --uf-accent: #e2e8f0;\n  --uf-accent-soft: #1d4ed8;\n  --uf-tab-track: #1c1a18;\n}\n\n.upload-family-page {\n  background-color: var(--uf-bg) !important;\n  color: var(--uf-text);\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.upload-family-page .uf-card {\n  border-color: color-mix(in srgb, var(--uf-border) 80%, transparent);\n  background: color-mix(in srgb, var(--uf-surface) 70%, transparent);\n}\n\n.upload-family-page .uf-surface {\n  background-color: var(--uf-surface) !important;\n  border-color: var(--uf-border) !important;\n  color: var(--uf-text);\n}\n\n.upload-family-page .uf-tab-track {\n  background-color: var(--uf-tab-track) !important;\n}\n\n.upload-family-page .uf-tab-active {\n  background-color: var(--uf-surface) !important;\n  color: var(--uf-accent) !important;\n}\n\n.upload-family-page .uf-footer-bar {\n  background: color-mix(in srgb, var(--uf-surface) 90%, transparent) !important;\n  border-color: var(--uf-border) !important;\n}\n\n/* ── Photo Themes hub ── */\n.photo-themes-hub {\n  --pt-text: #0f172a;\n  --pt-muted: #64748b;\n  --pt-card: rgba(255, 255, 255, 0.95);\n  --pt-card-border: rgba(15, 23, 42, 0.1);\n}\n\nhtml.dark .photo-themes-hub {\n  --pt-text: #ffffff;\n  --pt-muted: #a8a399;\n  --pt-card: rgba(28, 26, 24, 0.92);\n  --pt-card-border: rgba(255, 255, 255, 0.1);\n}\n\n.photo-themes-hub {\n  color: var(--pt-text);\n}\n\n.photo-themes-hub .pt-stat-card {\n  background: var(--pt-card);\n  border-color: var(--pt-card-border);\n}\n\n.photo-themes-glass-card {\n  border-radius: 1.5rem;\n  border: 1px solid color-mix(in srgb, var(--pt-card-border) 80%, transparent);\n  background: var(--pt-card);\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  backdrop-filter: blur(12px);\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.photo-themes-hub h2,\n.photo-themes-hub .pt-section-title {\n  color: var(--pt-text);\n}\n\n.photo-themes-hub .pt-muted {\n  color: var(--pt-muted);\n}\n\n/* ── Portal layout shell (all nav routes) ── */\n.portal-page-surface {\n  --pp-bg: #ffffff;\n  --pp-surface: #ffffff;\n  --pp-surface-muted: #f1f5f9;\n  --pp-text: #0f172a;\n  --pp-text-muted: #64748b;\n  --pp-text-faint: #94a3b8;\n  --pp-border: rgba(15, 23, 42, 0.1);\n  --pp-accent: #2563eb;\n  --pp-ink: #0f172a;\n  color: var(--pp-text);\n  font-family: \"Outfit\", \"Segoe UI\", sans-serif;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\nhtml.dark .portal-page-surface {\n  --pp-bg: #151412;\n  --pp-surface: #1c1a18;\n  --pp-surface-muted: #1d4ed8;\n  --pp-text: #ffffff;\n  --pp-text-muted: #a8a399;\n  --pp-text-faint: #78746c;\n  --pp-border: rgba(255, 255, 255, 0.1);\n  --pp-accent: #e2e8f0;\n  --pp-ink: #ffffff;\n  color-scheme: dark;\n}\n\n.portal-page-surface .portal-card {\n  border-radius: 1rem;\n  border: 1px solid var(--pp-border);\n  background-color: var(--pp-surface);\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.portal-page-surface .portal-header-bar {\n  background-color: var(--pp-bg);\n  border-bottom: 1px solid var(--pp-border);\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n/* Catch pages/components still using light-only Tailwind grays */\n.portal-page-surface .bg-white {\n  background-color: var(--pp-surface) !important;\n}\n\n.portal-page-surface .bg-gray-50,\n.portal-page-surface .bg-slate-50 {\n  background-color: var(--pp-surface-muted) !important;\n}\n\n.portal-page-surface .bg-gray-100,\n.portal-page-surface .bg-slate-100 {\n  background-color: var(--pp-surface-muted) !important;\n}\n\n.portal-page-surface .border-gray-100,\n.portal-page-surface .border-gray-200,\n.portal-page-surface .border-slate-200 {\n  border-color: var(--pp-border) !important;\n}\n\n.portal-page-surface .text-gray-900,\n.portal-page-surface .text-slate-900 {\n  color: var(--pp-text) !important;\n}\n\n.portal-page-surface .text-gray-800,\n.portal-page-surface .text-gray-700,\n.portal-page-surface .text-gray-600,\n.portal-page-surface .text-slate-800,\n.portal-page-surface .text-slate-700,\n.portal-page-surface .text-slate-600 {\n  color: var(--pp-text-muted) !important;\n}\n\n.portal-page-surface .text-gray-500,\n.portal-page-surface .text-gray-400,\n.portal-page-surface .text-gray-300,\n.portal-page-surface .text-slate-500,\n.portal-page-surface .text-slate-400 {\n  color: var(--pp-text-faint) !important;\n}\n\n/* Remap SaaS blues / violets / purples / indigos → ink / stone\n   (skip .sd-dash which has its own premium tokens) */\n.portal-page-surface:not(:has(.sd-dash)) .bg-blue-50,\n.portal-page-surface:not(:has(.sd-dash)) .bg-violet-50,\n.portal-page-surface:not(:has(.sd-dash)) .bg-purple-50,\n.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-50,\n.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-50,\n.portal-page-surface:not(:has(.sd-dash)) .bg-sky-50 {\n  background-color: var(--pp-surface-muted) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .bg-blue-100,\n.portal-page-surface:not(:has(.sd-dash)) .bg-violet-100,\n.portal-page-surface:not(:has(.sd-dash)) .bg-purple-100,\n.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-100 {\n  background-color: #f1f5f9 !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .bg-blue-500,\n.portal-page-surface:not(:has(.sd-dash)) .bg-blue-600,\n.portal-page-surface:not(:has(.sd-dash)) .bg-violet-500,\n.portal-page-surface:not(:has(.sd-dash)) .bg-violet-600,\n.portal-page-surface:not(:has(.sd-dash)) .bg-purple-500,\n.portal-page-surface:not(:has(.sd-dash)) .bg-purple-600,\n.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-500,\n.portal-page-surface:not(:has(.sd-dash)) .bg-indigo-600,\n.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-500,\n.portal-page-surface:not(:has(.sd-dash)) .bg-fuchsia-600 {\n  background-color: var(--pp-accent) !important;\n  color: #ffffff !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .text-blue-500,\n.portal-page-surface:not(:has(.sd-dash)) .text-blue-600,\n.portal-page-surface:not(:has(.sd-dash)) .text-blue-700,\n.portal-page-surface:not(:has(.sd-dash)) .text-violet-500,\n.portal-page-surface:not(:has(.sd-dash)) .text-violet-600,\n.portal-page-surface:not(:has(.sd-dash)) .text-violet-700,\n.portal-page-surface:not(:has(.sd-dash)) .text-purple-500,\n.portal-page-surface:not(:has(.sd-dash)) .text-purple-600,\n.portal-page-surface:not(:has(.sd-dash)) .text-purple-700,\n.portal-page-surface:not(:has(.sd-dash)) .text-indigo-500,\n.portal-page-surface:not(:has(.sd-dash)) .text-indigo-600,\n.portal-page-surface:not(:has(.sd-dash)) .text-indigo-700,\n.portal-page-surface:not(:has(.sd-dash)) .text-fuchsia-500,\n.portal-page-surface:not(:has(.sd-dash)) .text-fuchsia-600 {\n  color: var(--pp-accent) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .border-blue-100,\n.portal-page-surface:not(:has(.sd-dash)) .border-blue-200,\n.portal-page-surface:not(:has(.sd-dash)) .border-violet-100,\n.portal-page-surface:not(:has(.sd-dash)) .border-violet-200,\n.portal-page-surface:not(:has(.sd-dash)) .border-purple-100,\n.portal-page-surface:not(:has(.sd-dash)) .border-purple-200,\n.portal-page-surface:not(:has(.sd-dash)) .border-indigo-100,\n.portal-page-surface:not(:has(.sd-dash)) .border-indigo-200 {\n  border-color: var(--pp-border) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .border-blue-500,\n.portal-page-surface:not(:has(.sd-dash)) .border-violet-500,\n.portal-page-surface:not(:has(.sd-dash)) .border-purple-500,\n.portal-page-surface:not(:has(.sd-dash)) .border-indigo-500 {\n  border-color: var(--pp-accent) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .ring-blue-500,\n.portal-page-surface:not(:has(.sd-dash)) .ring-violet-500,\n.portal-page-surface:not(:has(.sd-dash)) .ring-purple-500,\n.portal-page-surface:not(:has(.sd-dash)) .ring-indigo-400,\n.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-blue-500:focus,\n.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-violet-500:focus,\n.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-purple-500:focus,\n.portal-page-surface:not(:has(.sd-dash)) .focus\\:ring-indigo-500:focus {\n  --tw-ring-color: rgba(37, 99, 235, 0.35) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-blue-50:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-violet-50:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-purple-50:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:bg-indigo-50:hover {\n  background-color: var(--pp-surface-muted) !important;\n}\n\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-blue-600:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-violet-600:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-purple-600:hover,\n.portal-page-surface:not(:has(.sd-dash)) .hover\\:text-indigo-600:hover {\n  color: var(--pp-accent) !important;\n}\n\nhtml.dark .portal-page-surface .hover\\:bg-gray-50:hover,\nhtml.dark .portal-page-surface .hover\\:bg-blue-50:hover,\nhtml.dark .portal-page-surface .hover\\:bg-slate-50:hover,\nhtml.dark .portal-page-surface .hover\\:bg-slate-100:hover {\n  background-color: var(--pp-surface-muted) !important;\n}\n\nhtml.dark .portal-page-surface .hover\\:text-gray-700:hover,\nhtml.dark .portal-page-surface .hover\\:text-gray-600:hover {\n  color: var(--pp-text) !important;\n}\n\n.portal-page-surface input,\n.portal-page-surface select,\n.portal-page-surface textarea {\n  background-color: var(--pp-surface);\n  border-color: var(--pp-border);\n  color: var(--pp-text);\n}\n\n.portal-page-surface input::placeholder,\n.portal-page-surface textarea::placeholder {\n  color: var(--pp-text-faint);\n}\n\nhtml.dark .portal-page-surface select option {\n  background-color: var(--pp-surface);\n  color: var(--pp-text);\n}\n\n/* ── Upload Family — hardcoded hex in JSX ── */\n.upload-family-page .text-\\[\\#004ac6\\] {\n  color: var(--uf-accent) !important;\n}\n\n.upload-family-page .text-\\[\\#505f76\\],\n.upload-family-page .text-\\[\\#5f6c84\\] {\n  color: var(--uf-muted) !important;\n}\n\n.upload-family-page .text-\\[\\#191b23\\],\n.upload-family-page .text-\\[\\#1a1c24\\] {\n  color: var(--uf-text) !important;\n}\n\n.upload-family-page .border-\\[\\#c3c6d7\\],\n.upload-family-page .border-\\[\\#d5d8e4\\] {\n  border-color: var(--uf-border) !important;\n}\n\n.upload-family-page .bg-\\[\\#f3f3fe\\],\n.upload-family-page .bg-\\[\\#f5f6ff\\],\n.upload-family-page .bg-\\[\\#eef4ff\\] {\n  background-color: var(--uf-surface-soft) !important;\n}\n\n.upload-family-page .bg-white {\n  background-color: var(--uf-surface) !important;\n}\n\n.upload-family-page .bg-\\[\\#004ac6\\] {\n  background-color: var(--uf-accent) !important;\n}\n\n.upload-family-page .border-\\[\\#004ac6\\] {\n  border-color: var(--uf-accent) !important;\n}\n\n/* ── Family tree floating panel ── */\n.family-tree-scope .family-tree-panel {\n  background: var(--pp-surface);\n  border-color: var(--pp-border);\n  color: var(--pp-text);\n}\n\nhtml.dark .family-tree-scope .family-tree-panel {\n  background: var(--pp-surface);\n  border-color: var(--pp-border);\n}\n\n.family-tree-scope .family-tree-panel .text-gray-800,\n.family-tree-scope .family-tree-panel .text-gray-700 {\n  color: var(--pp-text) !important;\n}\n\n.family-tree-scope .family-tree-panel .text-gray-500,\n.family-tree-scope .family-tree-panel .text-gray-400 {\n  color: var(--pp-text-faint) !important;\n}\n\n.family-tree-scope .family-tree-action {\n  border-color: var(--pp-border);\n  color: var(--pp-text-muted);\n}\n\nhtml.dark .family-tree-scope .family-tree-action:hover {\n  background-color: rgba(31, 58, 52, 0.2) !important;\n  border-color: #e2e8f0 !important;\n}\n\n/* ── Photo themes category (builder pages) ── */\n.photo-themes-hub,\n.photo-themes-category {\n  color: var(--pt-text);\n}\n\nhtml.dark .photo-themes-category .text-\\[\\#0b1c30\\],\nhtml.dark .photo-themes-category .text-\\[\\#464554\\] {\n  color: var(--pt-text) !important;\n}\n\nhtml.dark .category-quantum-studio {\n  background: #151412;\n  color: #ffffff;\n}\n\nhtml.dark .category-quantum-studio .bg-white,\nhtml.dark .category-quantum-studio .bg-white\\/90,\nhtml.dark .category-quantum-studio .category-editor-panel,\nhtml.dark .category-quantum-studio footer {\n  background-color: #1c1a18 !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\nhtml.dark .category-quantum-studio .bg-slate-50,\nhtml.dark .category-quantum-studio .bg-slate-50\\/80 {\n  background-color: #1d4ed8 !important;\n}\n\nhtml.dark .category-quantum-studio .text-\\[\\#0b1c30\\],\nhtml.dark .category-quantum-studio .text-slate-900,\nhtml.dark .category-quantum-studio h1,\nhtml.dark .category-quantum-studio h2,\nhtml.dark .category-quantum-studio h3 {\n  color: #ffffff !important;\n}\n\nhtml.dark .category-quantum-studio .text-\\[\\#464554\\],\nhtml.dark .category-quantum-studio .text-slate-600,\nhtml.dark .category-quantum-studio .text-slate-500 {\n  color: #a8a399 !important;\n}\n\nhtml.dark .category-quantum-studio .border-slate-100,\nhtml.dark .category-quantum-studio .border-slate-200,\nhtml.dark .category-quantum-studio .border-slate-200\\/60 {\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n/* ── Studio Albums + Client Images (scoped in page CSS) ── */\nhtml.dark .studio-albums-scope,\nhtml.dark .images-library-scope,\nhtml.dark .admin-scope,\nhtml.dark .premium-dashboard {\n  color-scheme: dark;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
